export const visit = (vm, at) => {
at({ "pt-br": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} de {{totalBytes}}" }, "fileSizeLimit": "O arquivo n\xE3o pode ser maior que {{size}}", "screenCapture": "Captura de tela" } } });
};